<template lang="es">
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="8" sm="12" md="8">
                        Administración de Campos para Resultados
                    </v-col>
                    <v-col cols="8" sm="12" md="4">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Crear nuevo
                        </v-btn>
                    </v-col>
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>

                <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12">
                        <v-text-field
                            outlined
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-data-table
                        :headers="headers"
                        :items="camposResultados"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :items-per-page="10"
                        dense
                        :search="tableFilter"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.descripcion }}</td>
                            <td>{{ item.nombreIndice }}</td>
                            <td>{{ item.principal == 1 ? 'SI' : 'NO' }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosid === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="800px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosCampoResultado.codigo"
                                label="Código del campo"
                                :rules="[
                                    required('Código del campo'),
                                    minLength('Código del campo', 3),
                                    maxLength('Código del campo', 50)
                                    
                                ]"
                                maxlength="50"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-textarea
                                rows="4"
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                counter="250"
                                v-model="datosCampoResultado.descripcion"
                                label="Descripción del campo de resultados"
                                :rules="[
                                    required('Descripción del campo'),
                                    minLength('Descripción del campo', 5),
                                    maxLength('Descripción del campo', 250),
                                   
                                ]"
                                maxlength="250"
                               
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-autocomplete
                                        v-model="datosCampoResultado.indicesid"
                                        :items="indices"
                                        class="required"
                                        dense
                                        outlined
                                        :loading="dialogLoaderVisible"
                                        label="Seleccionar Índice"
                                        item-text="nombreIndice"
                                        item-value="id"
                                        :rules="[
                                            selectRequired(
                                                'Índice'
                                            )
                                        ]"
                                    ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="principalSelecionado"
                                :items="principalOpciones"
                                class="required"
                                dense
                                outlined
                                label="Es campo princiapal del índice?"
                                item-text="nombre"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Principal'
                                    )
                                ]"
                            ></v-select>
                        </v-col>

                        
                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la etnia-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->

    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_CAMPOS_RESULTADOS, OBTENER_CAMPO_RESULTADOS, REGISTRAR_CAMPO_RESULTADOS, ACTUALIZAR_CAMPO_RESULTADOS } from "@/core/services/store/camposresultados/camposresultados.module";
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdmincamposResultados",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            validForm:false,
            itemName : "Campos resultado",
            dialog: false,
            modalTitle: 'Registrar Campo',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Campo',
            accion: 1,
            camposResultados: [],
            indices: [],
            switchItemEstado: true,
            principalOpciones: [{id: 1, nombre: 'Si'}, {id:2, nombre: 'No'}],
            principalSelecionado: 2,
            datosCampoResultado: {
                id: 0,
                codigo: '',
                indicesid: 0,
                principal:0,
                estadosid: 1
            },
            tableLoading: false,
            tableFilter:'',
            ...validations
        } 
    },
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Campo';
            this.btnRegistroText='Registrar Campo';
            this.dialog=true;
        },

        resetForm(){
             this.datosCampoResultado= {
                id: 0,
                codigo: '',
                indicesid: 0,
                principal:0,
                estadosid: 1
            };

            this.principalSelecionado=2;

            this.switchItemEstado = true;
        },

         async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });


        },


        //!Obtener los departamentos para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.camposResultados=[];
            
            this.$store
                .dispatch(OBTENER_CAMPOS_RESULTADOS)
                .then(res => {
                    if(res.status==200){
                        this.camposResultados = this.$store.state.camposresultados.camposResultados;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosCampoResultado.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Campo de Resutlados';
            this.btnRegistroText='Actualizar';

            this.$store
                .dispatch(OBTENER_CAMPO_RESULTADOS, Id)
                .then(res => {
                    if(res.status===200){
                    // let item = this.$store.state.departamento.departamento;
                        this.datosCampoResultado = this.$store.state.camposresultados.campoResultados;
                        this.datosCampoResultado.estadosid === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.datosCampoResultado.principal === 0 ? this.principalSelecionado=2 : this.principalSelecionado=1;

                       // console.log(this.principalSelecionado)
                        // this.datosCampoResultado.pais_Id = item.pais_Id
                        //console.log(this.datosEtnia)
                        this.dialog = true;
                    } else {
                         this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderVisible = false;
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                });
        },


   


        registrarItem(){
            //console.log(this.accion)
            
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosCampoResultado.estadosid = 1 : this.datosCampoResultado.estadosid = 2;

            this.principalSelecionado==2 ? this.datosCampoResultado.principal = 0 : this.datosCampoResultado.principal = 1;

            if(this.accion===1){
                this.datosCampoResultado.id = 0;
                this.$store
                    .dispatch(REGISTRAR_CAMPO_RESULTADOS, this.datosCampoResultado)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(() => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_CAMPO_RESULTADOS, this.datosCampoResultado)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(() => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema3.');
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Resultados" },
            { title: "Banco de Campos" }
        ]);
    },

    created(){
        this.obtnenerItems();
        this.obtenerIndices();
    },

    computed: {
        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                {
                    text: "Código",
                    value: "codigo"
                },
                {
                    text: "Descripcion",
                    value: "descripcion"
                },
                {
                    text: "Índice",
                    value: "nombreindice"
                },
                { 
                    text: "Principal",
                    value: "principal"
                },
               
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>